module.exports = __webpack_public_path__ + "img/ico-download.a32c9089.svg";